"use client";

import { ColumnDef } from "@tanstack/react-table";

import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";

import { statuses } from "../table-data/data";
import { Opportunity } from "../table-data/schema";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import moment from "moment";
import Link from "next/link";

export const columns: ColumnDef<Opportunity>[] = [
  {

    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Actions" />
    ),


    
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: ({ row }) => (
      <div className="w-[80px]">
        {moment(row.getValue("createdAt")).format("MM-DD-YY")}
      </div>
    ),
    enableSorting: false,
    enableHiding: false,
  },

  {
    accessorKey: "assigned_to_user",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),

    cell: ({ row }) => (
      <div className="w-[100px]">
        {
          //@ts-ignore
          //TODO: fix this
          row.getValue("assigned_to_user")?.name ?? "Unassigned"
        }
      </div>
    ),
    enableSorting: true,
    enableHiding: true,
  },
  {
    accessorKey: "assigned_account",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Account" />
    ),

    cell: ({ row }) => (
      <div className="w-[100px]">
        {
          //@ts-ignore
          //TODO: fix this
          row.getValue("assigned_account")?.name ?? "Unassigned"
        }
      </div>
    ),
    enableSorting: false,
    enableHiding: true,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Deal Name" />
    ),

    cell: ({ row }) => (
      <Link href={`/crm/opportunities/${row.original.id}`}>
        <div className="w-[100px]">{row.getValue("name")}</div>
      </Link>
    ),
    enableSorting: true,
    enableHiding: true,
  },
  {
    accessorKey: "budget",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Amount" />
    ),

    cell: ({ row }) => {
      //console.log(row.original.budget);
      return (
        <div>
          {row.original.budget
            ? row.original.budget.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })
            : "N/A"}
        </div>
      );
    },
    enableSorting: true,
    enableHiding: true,
  },  

  {
    id: "city",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="City" />
    ),
    cell: ({ row }) => {
      const city = row.original.assigned_leads?.city;
      return <div className="w-[120px]">{city || "N/A"}</div>;
    },
    enableSorting: true,
    enableHiding: true,
  },
  {
    id: "state",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="State" />
    ),
    cell: ({ row }) => {
      const state = row.original.assigned_leads?.state;
      return <div className="w-[60px]">{state || "N/A"}</div>;
    },
    enableSorting: true,
    enableHiding: true,
  },
  {
    id: "advisor",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Advisor" />
    ),
    cell: ({ row }) => {
      const advisor = row.original.assigned_leads?.advisorName;
      return <div className="max-w-[180px] truncate">{advisor || "N/A"}</div>;
    },
    enableSorting: true,
    enableHiding: true,
  },
  {
    id: "investorName",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Investor Name" />
    ),
    cell: ({ row }) => {
      const lead = row.original.assigned_leads;
      const investorName = lead
        ? `${lead.firstName || ""} ${lead.lastName || ""}`.trim()
        : "";
      return (
        <div className="max-w-[200px] truncate">
          {investorName || "N/A"}
        </div>
      );
    },
    enableSorting: true,
    enableHiding: true,
  },



];
